export default __webpack_public_path__ + "static/media/1267ccbd3c3c450483a57635a7631203-ProductDetailImage7b05a205-a15c-4619-9920-8cd6bae48acb.a0db7c2f.jpg";